import { SearchQuery } from "../api"
import compressFilterParameters from "./mappers/compressFilterParameters"
import compressSortParameters from "./mappers/compressSortParameters"
import mapOffsetToPage from "./mappers/mapOffsetToPage"
import { EncodedQuery } from "./mapping"
import { MapperOptions } from "./types"

function encode(query: SearchQuery, options: MapperOptions) {
    const q1 = mapOffsetToPage.encode(query, options)
    const q2 = compressSortParameters.encode(q1, options)
    return compressFilterParameters.encode(q2, options)
}

function decode(query: EncodedQuery, options: MapperOptions) {
    const q1 = mapOffsetToPage.decode(query, options)
    const q2 = compressSortParameters.decode(q1, options)
    return compressFilterParameters.decode(q2, options)
}

/**
 * @hidden
 */
export default {
    encode,
    decode
}
